import React, { useContext } from 'react'
import { Text } from '@usap/uicomponents'
import { SelectedItemsContext } from '../../contexts/SelectedItemsContextProvider'
import { OrderDetailsButtonContainer, OrderDetailsCtaWmo } from './OrderDetails/button/style/buttonWMO.css'

export default function ViewReturnInProgressDetailsButton({
    returnStatusData,
    setDisplayReturnDetails,
    setReturnDetailsData,
    isDesktop,
}) {
    const selectedItemsContextData = useContext(SelectedItemsContext)
    const {
        orderItems,
        setOrderItems,
    } = selectedItemsContextData

    const {
        message,
        returnRequestId,
        rmaId,
        merchantOrderId,
        creditId,
        email,
        orderId,
        orderItemId,
        imagesData = [],
    } = returnStatusData

    let idNumber = returnRequestId
    let idType = 'Return Request ID'

    if (creditId) {
        idNumber = creditId
        idType = 'Credit ID'
    }

    if (rmaId && rmaId !== 'GP RMA not received.') {
        idNumber = rmaId
        idType = 'RMA ID'
    }

    if (!returnRequestId && !rmaId && !creditId) return null

    const triggerReturnDetailsDisplay = () => {
        const dataReturn = {
            returnRequestId,
            merchantOrderId,
            orderId,
            orderItemId,
            rmaId,
            creditId,
            email,
        }
        if (orderItems && orderItems.length) setOrderItems([])
        setDisplayReturnDetails(true)
        setReturnDetailsData(dataReturn)
    }

    return (
        <OrderDetailsButtonContainer>
            <OrderDetailsCtaWmo
                custom
                hideBorder
                onClick={triggerReturnDetailsDisplay}
                label={<Text size={isDesktop ? '16px' : '14px'} color={'dark-2'}>View Return Details</Text>}
            />
        </OrderDetailsButtonContainer>
    )
}
